import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { APP_CONFIG } from "../lib/angular/injection-tokens";
import { IAppConfig } from "../lib/config/app-config";
import { SkillsCheck } from "../_models/SkillsCheck";
import { AppConstants } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class SkillsCheckService {
  public baseUrl: string = this.config.protectedResourceEndpoint;
  public static readonly path: string = "SkillsCheck/";

  constructor(
    private http: HttpClient,
    @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  public getLearnerSkillsCheck$(courseId: number): Observable<SkillsCheck[]> {
    return this.http.get<SkillsCheck[]>(
      `${this.baseUrl}${SkillsCheckService.path}${courseId}`
    );
  }

  public getLearnerSkillsCheckByLearnerId$(learnerId: number, courseId: number): Observable<SkillsCheck[]> {
    let params: HttpParams = new HttpParams();
    params = params.append(AppConstants.LEARNER_ID, String(learnerId));
    params = params.append(AppConstants.COURSE_ID, String(courseId));
    return this.http.get<SkillsCheck[]>(
      `${this.baseUrl}${SkillsCheckService.path}learner/skillscheck`,
      {params}
    );
  }

  public getIsSkillsCheckEnabled$(courseId: number): Observable<boolean> {
    return this.http.get<boolean>(
      `${this.baseUrl}${SkillsCheckService.path}getisenableskillschecktab/${courseId}`
    );
  }

  public getIsSkillsCheckEnabledByLearnerId$(learnerId: number, courseId: number): Observable<boolean> {
    let params: HttpParams = new HttpParams();
    params = params.append(AppConstants.LEARNER_ID, String(learnerId));
    params = params.append(AppConstants.COURSE_ID, String(courseId));
    
    return this.http.get<boolean>(
      `${this.baseUrl}${SkillsCheckService.path}learner/getisenableskillschecktab`,
      {params}
    );
  }
}
